module.exports = __webpack_public_path__ + "static/IWGHQI1-81f4337cfebf760cb22a5ac2efcd18ca.png";